<template>
    <div v-loading="loading">
        <div v-if="fieldLoaded">
            <DeleteDialog
                    title="Löschen"
                    text="Einheit wirklich löschen?"
                    :deleteMode="deleteMode"
                    :confirmCallback="deleteConfirmCallback"
            />
            <PanelForm :formVisible="showForm" :formData="editPanelData" :panelStatuses="panelStatuses" />
            <Breadcrumb />

            <el-card shadow="always">
                <div slot="header" class="clearfix">
                    <span>Sektor {{ field ? field.field_number : ''}}</span>
                    <el-button v-if="user_is_admin" style="float: right; padding: 3px 0" type="text" @click="addPanelClickHandler">Einheit hinzufügen</el-button>
                </div>

                <el-form ref="inputErrors" :model="inputErrors">
                    <el-row type="flex" justify="space-between">
                        <el-col>
                            <span style="font-size: 16px">Adresse des Gebäudes: {{ building.street }} {{ building.house_number }} {{ building.suffix }}</span>
                        </el-col>
                        <el-col>
                            <p style="font-size: 16px; text-align: right">
                                Total
                                <el-tag size="small">{{ field ? field.number_of_panels : '' }}</el-tag>
                            </p>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between">
                        <el-col>
                            <div class="panel-box">
                                <p><span class="available"></span> available
                                    <span class="locked"></span> locked
                                    <span class="reserved"></span> reserved
                                    <span class="taken"></span> taken
                                </p>
                            </div>
                        </el-col>
                        <el-col>
                            <p style="font-size: 16px; text-align: right">
                                Available
                                <el-tag size="small" type="success">{{ field ? field.available_panels : '' }}</el-tag>
                            </p>
                        </el-col>
                    </el-row>

                    <el-row></el-row>

                    <!--<el-row>-->
                        <!--<el-col :span="3">-->
                            <!--<el-checkbox v-model="samePriceChecked">Preis Einheit</el-checkbox>-->
                        <!--</el-col>-->

                        <!--<el-col :span="2">-->
                            <!--<el-input-->
                                    <!--v-if="samePriceChecked"-->
                                    <!--size="mini"-->
                                    <!--v-model="panelsCost"-->
                                    <!--type="number"-->
                                    <!--:placeholder="defaultPanelCost" />-->
                        <!--</el-col>-->
                        <!--<el-col v-if="loading" :span="1" :offset="1">-->
                            <!--<i class="el-icon-loading"></i>-->
                        <!--</el-col>-->
                    <!--</el-row>-->

                    <el-row></el-row>

                    <el-row v-if="field" :gutter="20">
                        <el-col
                                v-for="panel in field.panels"
                                :span="6"
                                :v-model="panel"
                                :key="panel.id">
                            <el-card class="panel-box">
                                <!--<div slot="header" class="header clearfix">-->
                                <el-row type="flex" justify="space-between" style="margin-bottom: 0">
                                    <el-col :span="16" class="clickable" @click.native="updatePanelClickHandler(panel)">
                                        <el-tooltip :content="panel.status_name" placement="top" effect="light">
                                            <span :class="panel.status_name"></span>
                                        </el-tooltip>
                                        {{ panel.panel_number }} {{ getPanelName(panel) }}
                                    </el-col>
                                    <el-col :span="6" class="clickable" @click.native="updatePanelClickHandler(panel)">
                                        {{ panel.panel_cost }}
                                    </el-col>
                                    <el-col v-if="user_is_admin" :span="2" :offset="2">
                                        <DeleteBtn @clicked="deleteClickHandler(panel)" />
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console,object-shorthand,func-names,new-parens,prefer-arrow-callback */
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    import DeleteDialog from '../../atoms/dialog/Delete';
    import PanelForm from './PanelForm';
    import Breadcrumb from '../../atoms/breadcrumb/Breadcrumb';
    import DeleteBtn from '../../atoms/button/DeleteBtn';
    import {
        DELETE_PANEL,
        FETCH_BUILDING,
        FETCH_FIELD, FETCH_WORDING,
        UPDATE_ALL_PANEL_PRICES,
        FETCH_PANEL_STATUSES,
    } from '../../../store/types';

    export default {
        name: 'Sector',
        components: { PanelForm, Breadcrumb, DeleteDialog, DeleteBtn },
        data () {
            return {
                fieldLoaded: false,
                samePriceChecked: false,
                panelsCost: '',
                showForm: false,
                deleteMode: false,
                deletePanelId: null,
                editPanelData: null,
                loading: false,
                panelStatuses: null,
                inputErrors: {
                    panels: {},
                },
            };
        },
        computed: {
            ...mapGetters(['get_buildings', 'get_building', 'get_field', 'get_panel', 'get_field_index', 'user_is_admin', 'get_wording']),
            defaultPanelCost () {
                const buildingId = this.$route.params.buildingId;
                return this.get_building(buildingId).default_panel_price;
            },
            building: {
                get () {
                    return this.get_building(this.$route.params.buildingId);
                },
                set (data) {
                    const building = this.get_building(this.$route.params.buildingId);
                    Object.assign({}, building, data);
                },
            },
            field () {
                return this.get_field(this.building, this.$route.params.fieldId);
            },
            fieldIndex () {
                return this.get_field_index(this.field);
            },
        },
        watch: {
            panelsCost: function (newVal) {
                if (typeof newVal === 'string') {
                    this.panelsCost = newVal.replace(/^0+/, '');
                    this.loading = true;
                    _.debounce(this.updateAllPanels, 500)();
                }
            },
        },
        created () {
            // Check if buildings are already in the state
            // fetch if not
            const routeParams = this.$route.params;

            if (!this.building || !this.building.fields || !this.field.panels) {
                this.loading = true;
                this.$store.dispatch(FETCH_BUILDING, routeParams.buildingId).then((resp) => {
                    this.building = resp;
                    this.$store.dispatch(FETCH_FIELD, routeParams.fieldId).then(() => {
                        this.fieldLoaded = true;
                        this.loading = false;
                        this.$store.dispatch(FETCH_WORDING).then(() => {
                            this.getPanelStatuses();
                        });
                    });
                });
            } else {
                this.fieldLoaded = true;
                this.$store.dispatch(FETCH_WORDING).then(() => {
                    this.getPanelStatuses();
                });
            }
        },
        methods: {
            updateAllPanels () {
                const data = { fieldId: this.field.id, cost: this.panelsCost };

                this.$store.dispatch(UPDATE_ALL_PANEL_PRICES, data)
                    .then((resp) => {
                        const building = this.get_building(resp.data.building.id);
                        this.field = this.get_field(building, resp.data.id);
                        this.$message.success(resp.message);
                        this.loading = false;
                    });
            },
            updatePanelClickHandler (panel) {
                this.editPanelData = panel;
                this.showForm = true;
            },
            addPanelClickHandler () {
                const buildingId = this.$route.params.buildingId;
                this.editPanelData = {
                    panel_cost: this.get_building(buildingId).default_panel_cost,
                };
                this.showForm = true;
            },
            deleteClickHandler (panel) {
                this.deletePanel = panel;
                this.deleteMode = true;
            },
            deleteConfirmCallback () {
                this.$store.dispatch(DELETE_PANEL, this.deletePanel).then((resp) => {
                    this.deleteMode = false;
                    this.$message.success(resp.message);
                });
            },
            getPanelStatuses () {
                this.$store.dispatch(FETCH_PANEL_STATUSES).then((resp) => {
                    this.panelStatuses = resp.data;
                });
            },
            getPanelTagType (panelStatus) {
                let type = '';
                switch (panelStatus) {
                    case 'available':
                        type = 'success';
                        break;
                    case 'reserved':
                        type = 'warning';
                        break;
                    default:
                        type = 'danger';
                }

                return type;
            },
            getPanelName (panel) {
                const panelNameLength = 8;
                let panelName = '';

                if (panel.panel_name && panel.panel_name.length > panelNameLength) {
                    panelName = panel.panel_name.substring(0, panelNameLength);
                    panelName += '...';
                } else {
                    panelName = panel.panel_name;
                }

                return panelName;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .el-form-item {
        &.valid {
            .el-input {
                border-color: #67c23a !important;
            }
        }
    }
    .clickable {
        cursor: pointer;
    }
    .panel-box {
        margin-bottom: 1rem;
        .header {
            .el-row {
                margin-bottom: 0;
            }
        }
        .info {
            p {
                font-size: 14px;
            }
            .input-label {
                display: inline-block;
                width: 130px;
            }
        }

        span {
            &::after {
                content: '';
                width: 10px;
                height: 10px;
                display: inline-block;
                border-radius: 50%;
            }
            &.available::after {
                background-color: rgb(103,194,58);
            }
            &.locked::after {
                background-color: rgb(0,0,0);
            }
            &.reserved::after {
                background-color: rgb(230,162,60);
            }
            &.taken::after {
                background-color: rgb(245,108,108);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/fields/Field.vue